import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/avatar';
import { Button } from '@/components/shadcn/button';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@/components/shadcn/popover';

import avatar from '../assets/main-logo.ico';
import { Conversation } from '@/components/Conversation';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import { ScrollArea } from '@/components/shadcn/scroll-area';
import { useTranslation } from 'react-i18next';
import { useRTL } from '@/hooks';
import { useLocalStorage } from '@/utils';
import useConversationMessage from '@/hooks/useConversationMessage';
import { ChatMetadataParams, useChatMetadata } from '@/hooks/useChatMetadata';
import { useEffect, useRef } from 'react';

interface Props {
  className?: string;
}

export default function FeedbackChat({ className }: Props) {
  const { isRTL } = useRTL();
  const { data } = useAdminSettings();
  const [email] = useLocalStorage('email', ''); // TODO: this is a bad practice. there is an issue with the localstorage logic

  const containerRef = useRef<HTMLDivElement>(null);

  const chatParams: ChatMetadataParams = {
    chatId: data?.chatId || '',
    sessionID: email,
  };

  const { data: chatMetadata } = useChatMetadata(chatParams);
  const { loading, messages, sendMessage, initChat } = useConversationMessage(chatParams);

  useEffect(() => {
    if (!chatMetadata) return;
    initChat(chatMetadata);
  }, [data?.chatId, email, chatMetadata]);

  const { t } = useTranslation();

  if (data && data.chatId && chatMetadata) {
    const buttonText = t('feedback.buttonText');
    const botName = t('feedback.botName');

    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button
            className="bg-purple-50 text-black hover:bg-purple-200 active:bg-purple-200 cursor-pointer"
            variant="secondary"
          >
            {buttonText}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          side="top"
          align="end"
          sideOffset={-20}
          collisionPadding={20}
          dir={isRTL ? 'rtl' : 'ltr'}
          className="p-0 m-0 w-fit h-fit"
        >
          <PopoverHeader className="flex justify-center items-center bg-purple-50 p-2">
            <PopoverClose />
            <Avatar>
              <AvatarImage className="object-cover object-top" src={avatar} />
              <AvatarFallback>{botName}</AvatarFallback>
            </Avatar>
            <p className="text-primary">{botName}</p>
          </PopoverHeader>
          <ScrollArea
            dir={isRTL ? 'rtl' : 'ltr'}
            className="h-[500px] w-[320px]  flex flex-col"
            ref={containerRef}
          >
            <Conversation
              className="h-[500px]"
              newMessageScrollTarget={containerRef}
              chatMetadata={chatMetadata}
              messages={messages}
              loading={loading}
              onSend={sendMessage}
            />
          </ScrollArea>
        </PopoverContent>
      </Popover>
    );
  }

  return null;
}
